import { type ParsedContact, makeContact } from "../contact";
import { type VCardProperty, splitComponents, unescapeValue } from "../vcard";

/** `ADR` is PO box; extended; street; locality; region; postcode; country. */
const address = (value: string): string => {
	const [, , street, locality, region, postcode, country] =
		splitComponents(value);
	return [street, locality, region, postcode, country]
		.filter((part) => part !== undefined && part.trim() !== "")
		.join(", ");
};

/** `N` is family; given; additional; prefix; suffix. */
const structuredName = (value: string): string => {
	const [family, given, additional, prefix, suffix] = splitComponents(value);
	return [prefix, given, additional, family, suffix]
		.filter((part) => part !== undefined && part.trim() !== "")
		.join(" ");
};

export const vcardContacts = (
	cards: readonly (readonly VCardProperty[])[],
): ParsedContact[] =>
	cards.map((card, index) => {
		const first = (name: string) =>
			card.find((property) => property.name === name);
		const all = (name: string) =>
			card
				.filter((property) => property.name === name)
				.map((property) => unescapeValue(property.value));
		const plain = (name: string) => unescapeValue(first(name)?.value ?? "");
		const adr = first("ADR");

		return makeContact(index + 1, {
			name: plain("FN") || structuredName(first("N")?.value ?? ""),
			organisation: splitComponents(first("ORG")?.value ?? "")[0],
			position: plain("TITLE"),
			emails: all("EMAIL"),
			phones: all("TEL"),
			location: adr ? address(adr.value) : plain("LABEL"),
			note: plain("NOTE"),
			// KTD9: UID is reference only, never an identity.
			sourceRef: plain("UID"),
		});
	});
